module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isInApp) ? _vm._m(0) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', {
    on: {
      "click": _vm.jumpUrl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.imageSrc),
      "alt": "download All Football App",
      "width": "100%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1203ba","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadHeader.vue
// module id = 512
// module chunks = 1 2 3 4 5 6